import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { formatDateTime } from '../../../../util/datetime'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TECHNICAL_LOG_CONTAINER } from '../../ui-definition/process-ui'

const PRE_STYLE = {
    width: '100%',
    height: '300px',
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
    padding: '9.5px',
    borderRadius: '3px',
}

const TABLE_STYLE = {
    tableLayout: 'auto',
}

const TechnicalLog = ({ processLogList, context }) => {
    if (!currentUserHasAccess(TECHNICAL_LOG_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Technical Log">
            <Row>
                <Column size={12}>
                    <table className="default-table" style={TABLE_STYLE}>
                        <thead>
                            <tr>
                                <th>Time</th>
                                <th>Event</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {processLogList.map(processLog => {
                                return (
                                    <tr key={processLog.id}>
                                        <td>{formatDateTime(processLog.created)}</td>
                                        <td>{processLog.event}</td>
                                        <td>{processLog.text}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <textarea style={PRE_STYLE} readOnly={true} value={JSON.stringify(context, null, 2)}/>
                </Column>
            </Row>
        </ContentBox>
    )
}


TechnicalLog.propTypes = {
    context: PropTypes.object,
    processLogList: PropTypes.array,
}


export default TechnicalLog



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/TechnicalLog.js